import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Text } from "@miro-site/core";
import { useTheme } from "styled-components";
import { useTranslation } from "next-i18next";
/**
 * Used to output flip card tags that a user can set
 * in our contentful general templates collection
 */ export var CardTags = function(param) {
    var descriptionStyles = param.descriptionStyles, headingStyles = param.headingStyles, tags = param.tags;
    if (!Array.isArray(tags) || !(tags === null || tags === void 0 ? void 0 : tags.length)) {
        return null;
    }
    var theme = useTheme();
    var t = useTranslation("common").t;
    return /*#__PURE__*/ _jsxs(Box, {
        $styles: {
            backgroundColor: theme.templates.colors.secondary4,
            padding: [
                16,
                20
            ],
            marginBottom: 24,
            borderRadius: 8
        },
        children: [
            /*#__PURE__*/ _jsx(Text, {
                as: "h4",
                $color: "primaryIndigo",
                $mb: 12,
                $styles: _object_spread({
                    fontWeight: 700,
                    fontSize: 14,
                    lineHeight: 20
                }, headingStyles),
                children: t("works-best-for")
            }),
            /*#__PURE__*/ _jsx(Text, {
                $variant: [
                    "p1",
                    "p2",
                    "p2",
                    "p2"
                ],
                $styles: _object_spread({
                    color: theme.templates.colors.secondary60,
                    fontSize: 14,
                    lineHeight: 20
                }, descriptionStyles),
                children: tags.join(", ")
            })
        ]
    });
};
